import {
  AutocompleteField,
  CheckboxField,
  RsFormsExtentionFormFieldRegistry,
  ToggleField,
} from '@rs-bank/rs-forms-extention';

import {
  AmountFieldComponent,
  DateInputFieldComponent,
  InformationFieldComponent,
  InformationWithProgressFieldComponent,
  InputFieldComponent,
  RadioButtonFieldComponent,
  SelectFieldComponent,
  TabsFieldComponent,
} from './field-components';
import { AddressFieldComponent } from './field-components/address-field/address-field.component';
import { AutocompleteFieldComponent } from './field-components/autocomplete-field/autocomplete-field.component';
import { CheckboxFieldComponent } from './field-components/checkbox-field/checkbox-field.component';
import { ComponentFieldComponent } from './field-components/component-field/component-field.component';
import { EditorFieldComponent } from './field-components/editor-field/editor-field.component';
import { OperationTemplateFieldComponent } from './field-components/operation-template-field/operation-template-field.component';
import { SelectFieldWithPopUpComponent } from './field-components/select-field-with-pop-up/select-field-with-pop-up.component';
import { SplittedInputFieldComponent } from './field-components/splitted-input-field/splitted-input-field.component';
import { ToggleFieldComponent } from './field-components/toggle-field/toggle-field.component';
import {
  AddressField,
  EditField,
  IbAmountField,
  IbDateInputField,
  IbInformationField,
  IbInformationWithProgressField,
  IbInputField,
  IbSelectField,
  IbSelectWithPopUpField,
} from './field-types';
import { IbAutocompleteField } from './field-types/autocomplete.ib.field-types';
import { IbComponentField } from './field-types/component.ib.field-types';
import { OperationTemplateField } from './field-types/operation-template.ib.field-type';
import { IbRadioButtonField } from './field-types/radio-button.ib.field-type';
import { IbSplittedInputField } from './field-types/splitted-input.ib.field-types';
import { IbTabsField } from './field-types/tabs.ib.field-types';
import { IbToggleField } from './field-types/toggle.ib.field-type';


export class InternetbankFieldsRegisrty extends RsFormsExtentionFormFieldRegistry {

	constructor() {

		super();

		this.registry.set(AddressField, AddressFieldComponent);
		this.registry.set(IbAmountField, AmountFieldComponent);
		this.registry.set(IbDateInputField, DateInputFieldComponent);
		this.registry.set(EditField, EditorFieldComponent);
		this.registry.set(IbInformationField, InformationFieldComponent);
		this.registry.set(IbInformationWithProgressField, InformationWithProgressFieldComponent);
		this.registry.set(IbInputField, InputFieldComponent);
		this.registry.set(IbSelectField, SelectFieldComponent);
		this.registry.set(IbSelectWithPopUpField, SelectFieldWithPopUpComponent);
		this.registry.set(CheckboxField, CheckboxFieldComponent);
		this.registry.set(ToggleField, ToggleFieldComponent);
		this.registry.set(IbToggleField, ToggleFieldComponent);
		this.registry.set(AutocompleteField, AutocompleteFieldComponent);
		this.registry.set(IbAutocompleteField, AutocompleteFieldComponent);
		this.registry.set(IbTabsField, TabsFieldComponent);
		this.registry.set(OperationTemplateField, OperationTemplateFieldComponent);
		this.registry.set(IbSplittedInputField, SplittedInputFieldComponent);
		this.registry.set(IbRadioButtonField, RadioButtonFieldComponent);
		this.registry.set(IbComponentField, ComponentFieldComponent);


		this.registry.set('address', AddressFieldComponent);
		this.registry.set('amount', AmountFieldComponent);
		this.registry.set('date-input', DateInputFieldComponent);
		this.registry.set('edit', EditorFieldComponent);
		this.registry.set('information', InformationFieldComponent);
		this.registry.set('information-with-progress', InformationWithProgressFieldComponent);
		this.registry.set('input', InputFieldComponent);
		this.registry.set('select', SelectFieldComponent);
		this.registry.set('checkbox', CheckboxFieldComponent);
		this.registry.set('toggle', ToggleFieldComponent);
		this.registry.set('autocomplete', AutocompleteFieldComponent);
		this.registry.set('operation-template', OperationTemplateFieldComponent);
		this.registry.set('splitted-input', SplittedInputFieldComponent);
		this.registry.set('radio-button', RadioButtonFieldComponent);
	}
}
